import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getColor, type Theme } from 'styles/theme';

export const DrawerToggle = styled.input`
  &.drawer-toggle {
    display: none;

  &:checked {
    & ~ .drawer-menu {
      visibility: visible;
      left: 0;
      overflow: hidden;
    }

    & ~ .overlay {
      visibility: visible;
      opacity: 0.5;
    }
  }
}
`;

export const DisclaimerWrapper = styled.div`
  position: sticky;
  top: 79px;
  z-index: 1002;
  @media (${breakpoint.mdMin}) {
    top: 55px;
  } 
`;

export const DisclaimerArticleWrapper = styled.div`
  position: sticky;
  /* !! use 0px instead of 0, otherwise top will be considered auto */
  top: calc(var(--cc-sbillboard-min-height, var(--ld-height, 0px)) + 79px);
  z-index: 10;
  @media (${breakpoint.mdMin}) {
    top: calc(var(--cc-sbillboard-min-height, var(--ld-height, 0px)) + 55px);
    margin-bottom: 40px;
  }
`;

export const DrawerToggleButton = styled.label<{ theme: Theme }>`
  &.hamburger-toggle {
    display: block;
    width: 24px;
    height: 24px;
    cursor: pointer;
    margin-right: 16px;
    position: relative;

    @media (${breakpoint.lgMin}) {
	  margin-right: 24px;	
	} 
    
    svg {
      transition: all .2s ease-in-out;
      width: 24px;
      height: 24px;
    }

    &:hover {
      svg{
        fill: ${getColor('textSecondary')};
        transition: all .2s ease-in-out;
      }
    }

    &:focus, &:active {
      svg {
        fill: ${getColor('iconSecondary')};
      }
    }
  }

  &.close-menu {
    cursor: pointer;
    
    .close-icon {
      stroke: ${getColor('iconPrimary')};
      transition: stroke 0.2s ease-in-out;
    }

    &:hover .close-icon {
      stroke: ${getColor('textSecondary')};
    }
  }
`;
